import React from 'react';
import { Box, Typography } from '@mui/material';
import DubbingJobCard from './DubbingJobCard';
import LoadingSpinner from '../common/LoadingSpinner/LoadingSpinner';

const JobsList = ({ loading, error, jobs, activeTab, tabFilters, onPlay, onDownload, onCancel, onDelete, onRetry }) => {
  if (loading) {
    return <LoadingSpinner message="Loading your dubbing jobs..." size={50} />;
  }

  if (error) {
    return (
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography sx={{ color: '#EF4444', fontFamily: 'Inter, sans-serif', fontWeight: 600, mb: 1 }}>
          Error Loading Jobs
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.35)', fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
          {error}
        </Typography>
      </Box>
    );
  }

  if (jobs.length === 0) {
    return (
      <Box sx={{
        py: 10,
        textAlign: 'center',
        border: '1px dashed rgba(255,255,255,0.08)',
        borderRadius: '12px',
      }}>
        <Typography sx={{ color: 'rgba(255,255,255,0.25)', fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '15px', mb: 0.75 }}>
          {activeTab === 0 ? 'No dubbing jobs yet' : `No ${tabFilters[activeTab]?.label?.toLowerCase()} jobs`}
        </Typography>
        {activeTab === 0 && (
          <Typography sx={{ color: 'rgba(255,255,255,0.2)', fontFamily: 'Inter, sans-serif', fontSize: '13px' }}>
            Create your first dub to get started.
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: '1fr 1fr',
        lg: '1fr 1fr 1fr',
      },
      gap: 2,
    }}>
      {jobs.map((job) => (
        <DubbingJobCard
          key={job.job_id}
          job={job}
          onPlay={onPlay}
          onDownload={onDownload}
          onCancel={onCancel}
          onDelete={onDelete}
          onRetry={onRetry}
        />
      ))}
    </Box>
  );
};

export default JobsList;
